import { inject } from '@angular/core';
import { CanMatchFn, Route } from '@angular/router';

import { ngxPermissionsGuard } from 'ngx-permissions';

import { environment } from '@kr/environment';
import { LoginType } from '@kr/src/models';
import { AuthService } from '@kr/store';

import { appPermissionsGuard } from './init/app-permissions.guard';
import { ShellComponent } from './shell/shell.component';

const signedOutUser: CanMatchFn = () => {
  const auth = inject(AuthService);

  return auth.signedOutCheck();
};

const signedInUser: CanMatchFn = () => {
  const auth = inject(AuthService);

  return auth.signedInCheck();
};

const permissionGuard = environment.loginType === LoginType.Internal ? ngxPermissionsGuard : appPermissionsGuard;

export const appRoutes: Route[] = [
  {
    path: 'signin',
    title: 'Sign In',
    loadComponent: () => import('./pages/signin/signin.component').then(m => m.SigninComponent),
    canMatch: [signedOutUser],
  },
  {
    path: 'user-not-found',
    title: 'User not found',
    loadComponent: () => import('./pages/user-not-found/user-not-found.component').then(m => m.UserNotFoundComponent),
  },
  {
    path: '',
    component: ShellComponent,
    canMatch: [signedInUser],
    children: [
      {
        path: '404',
        title: '404',
        loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
      },
      {
        path: '',
        pathMatch: 'full',
        title: 'Home Page',
        canMatch: [permissionGuard],
        data: { permissions: { only: 'treasurerDashboard', redirectTo: '/account' } },
        loadChildren: () => import('./pages/home/home.routes').then(m => m.homeRoutes),
      },
      {
        path: 'wallets',
        title: 'Wallets',
        canMatch: [permissionGuard],
        data: { permissions: { only: 'treasurerWallets', redirectTo: '/account' } },
        loadChildren: () => import('./pages/wallets/wallets.routes').then(m => m.walletsRoutes),
      },
      {
        path: 'api',
        title: 'API',
        canMatch: [permissionGuard],
        data: {
          permissions: {
            only: ['treasurerWallets', 'limiterLimits'],
            redirectTo: '/account',
          },
        },
        loadChildren: () => import('./pages/pseudo-wallets/pseudo-wallets.routes').then(m => m.pseudoWalletsRoutes),
      },
      {
        path: 'limits',
        title: 'Limits',
        canMatch: [permissionGuard],
        data: { permissions: { only: 'limiterLimits', redirectTo: '/account' } },
        loadChildren: () => import('./pages/limits/limits.routes').then(m => m.limitsRoutes),
      },
      {
        path: 'risk-score',
        title: 'Risk score',
        loadChildren: () => import('./pages/risk-score/risk-score.component.routes').then(m => m.riskScoreRoutes),
      },
      // {
      //   path: 'exchange',
      //   title: 'Exchange',
      //   loadChildren: () => import('./pages/exchange-page/exchange-page.routes').then(m => m.exchangePageRoutes),
      // },
      {
        path: 'account',
        title: 'Account',
        loadChildren: () => import('./pages/account/account.routes').then(m => m.accountRoutes),
      },
      // {
      //   path: 'companies',
      //   title: 'Companies',
      //   canMatch: [ngxPermissionsGuard],
      //   data: { permissions: { only: 'limiterLimits', redirectTo: '/account' } },
      //   loadChildren: () => import('./pages/companies/companies.routes').then(m => m.companiesRoutes),
      // },
      {
        path: '**',
        redirectTo: '404',
      },
    ],
  },
];
